import React, { useCallback, useEffect, useRef } from 'react'

import useKva, { LANDING_PAGE_LENDING } from '@/hooks/useKVA'

export default function Layout({ children }) {
  const scrollableRef = useRef({
    oneQuarter: false,
    half: false,
    threeQuarters: false,
    full: false,
  })

  const { addEventAction } = useKva()
  const handleScroll = useCallback(() => {
    const { scrollY } = window
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    const scrollYHeight = scrollHeight - clientHeight
    const isScrolledTo25Percent = scrollY >= (scrollYHeight / 4).toFixed(0) - 2
    const isScrolledTo50Percent = scrollY >= scrollYHeight / 2
    const isScrolledTo75Percent = scrollY >= scrollYHeight * 0.75
    const isScrolledTo100Percent = scrollY >= scrollYHeight
    if (isScrolledTo25Percent && !scrollableRef.current.oneQuarter) {
      scrollableRef.current.oneQuarter = true
      addEventAction(LANDING_PAGE_LENDING, 'scroll_page_25')
    }
    if (isScrolledTo50Percent && !scrollableRef.current.half) {
      scrollableRef.current.half = true
      addEventAction(LANDING_PAGE_LENDING, 'scroll_page_50')
    }
    if (isScrolledTo75Percent && !scrollableRef.current.threeQuarters) {
      scrollableRef.current.threeQuarters = true
      addEventAction(LANDING_PAGE_LENDING, 'scroll_page_75')
    }
    if (isScrolledTo100Percent && !scrollableRef.current.full) {
      scrollableRef.current.full = true
      addEventAction(LANDING_PAGE_LENDING, 'scroll_page_100')
    }
  }, [addEventAction])

  // useEffect(() => {
  //   addEventPageView(LANDING_PAGE_LENDING)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', () => {
        handleScroll()
      })
      return window.removeEventListener('scroll', () => {
        handleScroll()
      })
    }
  }, [handleScroll])

  return (
    <>
      <div>{children}</div>
    </>
  )
}
